export default (theme) => ({
    root: {
        width: '100%',
        height: '100%',
        marginTop: 14,
        display: 'flex',
        flexDirection: 'column',
        justifySelf: 'start',
        gap: 14,
    },
    error: {
        margin: '4px 0px 4px 52px',
        display: 'flex',
        alignItems: 'center',
        gap: 8,

        button: {
            ...theme.typography.body,
        },
    },
});
